import { AnalyticsGTM, IAnalytics } from '@quicktools/shared-components/services/analytics-gtm';
import { GA4 } from 'react-ga4/types/ga4';
import ReactGA4 from 'react-ga4';

import { TOOL_NAME, VERSION } from '../../configs';

import {
  AppRoute,
  FileUploadParam,
  ColorPaletteFromImageEventType,
  PageType,
  PopupActionParam,
} from './types';

class ColorPaletteFromImage extends AnalyticsGTM {
  constructor(public options: IAnalytics, ga4Instance: GA4) {
    super(options, ga4Instance);
  }

  public landingPage() {
    this.sendGaEvent(ColorPaletteFromImageEventType.PAGE_OPEN, {
      page_name: PageType.LANDING_PAGE,
      non_interaction: true,
    });
    this.hjEvent(ColorPaletteFromImageEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.HOME);
  }

  public editorPage() {
    this.sendGaEvent(ColorPaletteFromImageEventType.PAGE_OPEN, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.PAGE_OPEN);
    this.hjStateChange(AppRoute.EDITOR);
  }

  public toggleClick() {
    this.sendGaEvent(ColorPaletteFromImageEventType.TOGGLE_CLICK, {
      page_name: PageType.LANDING_PAGE,
    });
    this.hjEvent(ColorPaletteFromImageEventType.TOGGLE_CLICK);
  }
  public circleDrag() {
    this.sendGaEvent(ColorPaletteFromImageEventType.CIRCLE_DRAG, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.CIRCLE_DRAG);
  }

  public paletteDelete() {
    this.sendGaEvent(ColorPaletteFromImageEventType.DELETE_PALETTE, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.DELETE_PALETTE);
  }

  public addColor() {
    this.sendGaEvent(ColorPaletteFromImageEventType.COLOR_ADD, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.COLOR_ADD);
  }

  public startOver() {
    this.sendGaEvent(ColorPaletteFromImageEventType.START_OVER, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.START_OVER);
  }

  public exportClick() {
    this.sendGaEvent(ColorPaletteFromImageEventType.EXPORT_CLICK, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.EXPORT_CLICK);
  }

  public undoRedoClick() {
    this.sendGaEvent(ColorPaletteFromImageEventType.UNOD_REDO_CLICK, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.UNOD_REDO_CLICK);
  }

  public linkCopy() {
    this.sendGaEvent(ColorPaletteFromImageEventType.LINK_COPY, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.LINK_COPY);
  }

  public qrCodeChoose() {
    this.sendGaEvent(ColorPaletteFromImageEventType.QR_CODE_CHOOSE, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.QR_CODE_CHOOSE);
  }

  public pdfSave() {
    this.sendGaEvent(ColorPaletteFromImageEventType.PDF_SAVE, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.PDF_SAVE);
  }

  public popupOpen() {
    this.sendGaEvent(ColorPaletteFromImageEventType.POPUP_OPEN, {
      page_name: PageType.EDITOR,
      popup_name: 'start_over',
    });
    this.hjEvent(ColorPaletteFromImageEventType.POPUP_OPEN);
  }

  public popupAction(params: PopupActionParam) {
    this.sendGaEvent(ColorPaletteFromImageEventType.POPUP_ACTION, {
      page_name: PageType.EDITOR,
      popup_name: 'start_over',
      ...params,
    });
    this.hjEvent(ColorPaletteFromImageEventType.POPUP_ACTION);
  }

  public explorePalette() {
    this.sendGaEvent(ColorPaletteFromImageEventType.PALETTE_EXPLORE, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.PALETTE_EXPLORE);
  }

  public paletteClick() {
    this.sendGaEvent(ColorPaletteFromImageEventType.PALETTE_CLICK, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.PALETTE_CLICK);
  }

  public download() {
    this.sendGaEvent(ColorPaletteFromImageEventType.FILE_DOWNLOAD, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.FILE_DOWNLOAD);
  }

  public fileDownload() {
    this.sendGaEvent(ColorPaletteFromImageEventType.FILE_DOWNLOAD, {
      page_name: PageType.EDITOR,
    });
    this.hjEvent(ColorPaletteFromImageEventType.FILE_DOWNLOAD);
  }

  public fileUpload(params: FileUploadParam) {
    this.sendGaEvent(ColorPaletteFromImageEventType.FILE_UPLOAD, {
      page_name: PageType.LANDING_PAGE,
      ...params,
    });
    this.hjEvent(ColorPaletteFromImageEventType.FILE_UPLOAD);
  }
}

export default new ColorPaletteFromImage(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
